import { format, parseISO } from 'date-fns';

import CoreConfig from '../../../CoreConfig';

type IDate = {
    className?: string;
    dateStringOrTimestamp: any;
    format?: string;
};

export const parseTimeStringToDate = (dateStringOrTimestamp: string): Date => {
    // eslint-disable-next-line no-restricted-globals
    let date = isNaN(Number(dateStringOrTimestamp))
        ? parseISO(dateStringOrTimestamp)
        : new Date(
              parseInt(dateStringOrTimestamp, 10) > 9999999999
                  ? dateStringOrTimestamp
                  : parseInt(dateStringOrTimestamp, 10) * 1000
          );

    if (date.toString() === 'Invalid Date') {
        date = new Date(dateStringOrTimestamp);
    }

    return date;
};

export default function DateFormat(props: IDate) {
    const { dateStringOrTimestamp, className, format: dateFormat } = props;

    const date = parseTimeStringToDate(dateStringOrTimestamp);

    try {
        return (
            <time
                dateTime={date.toLocaleString('en-GB', { timeZone: CoreConfig.timezone, timeZoneName: 'long' })}
                className={className}
            >
                {format(date, dateFormat || 'LLLL d, yyyy')}
            </time>
        );
    } catch (error) {
        console.error(error);
        return null;
    }
}
